export enum UserRole {
    SuperAdmin, Admin, BrandAmbassador, SectorManager, Basic
}